import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DevicesClass } from '@app/core/classes/component/devices.class';
import { NewsService } from '@app/modules/news-modules/news.service';
import { IBlogPostNewsDetail } from '@app/modules/news-modules/news.models';
import { AppStaticURL } from '@app/app.settings';
import { RoutingConfig } from '@app/routing/routing.config';
import { PrimeNGConfig } from 'primeng/api';
declare var $;
// import 'slick-carousel/slick/slick.js';

@Component({
  selector: 'shared-main-news',
  templateUrl: 'main-news.component.html',
  styleUrls: [`./main-news.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MainNewsComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;
  public StaticURL = AppStaticURL;
  public NewsListData: Array<IBlogPostNewsDetail> = [];
  public NewsLoading: boolean = true;
  public NewsThumbnailError: boolean = false;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private router: Router,
    private newsService: NewsService,
    private primengConfig: PrimeNGConfig,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;

    /**
     * Getting of main news.
     */
    this.newsService.getAllNews(13).subscribe(
      response => {
        response.items.splice(0, 5);

        this.NewsLoading = false;
        this.NewsListData.push(...response.items);
        this.cdr.markForCheck();

        /**
         * Hook of Slick plugin init.
         */
        setTimeout(() => this.onMainNewsGalleryFn(), 100)
      }
    );
  }

  onMainNewsGalleryFn(): void {
    if (typeof $ === 'function') {
      $('.main-news__slide').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }

  onViewAllNews(): void {
    this.router.navigateByUrl('/' + this.Routing.News).catch();
  }
}
